import React, { useEffect, useState, useRef } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { ConfirmationAlert, triggerAlert, getOnlyToken } from '../../utils/commonFunctions';
import { _get, DeleteAgentByID, getFolders } from '../../utils/APIClient';
import Header from '../../common/Header';
import Sidebar from '../../common/Sidebar';
import PageHeader from '../PageHeader';
import Cookies from 'js-cookie';
import Loader from '../../common/Loader';


export default function AgentsList() {
    document.title = "Digital Employees | AI Agents"
    const [ListofAiAgents, setListofAiAgents] = useState([])
    const [agentLoading, setAgentLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [showCreateAgentModal, setShowCreateAgentModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();
    const access_privileges = JSON.parse(Cookies.get("modulepermissions"))
    const [customerlist, setcustomerlist] = useState(false)
    const [customeradd, setcustomeradd] = useState(false)
    const [customeredit, setcustomeredit] = useState(false)
    const [customerdelete, setcustomerdelete] = useState(false)
    const [creditCostDialogOpen, setCreditCostDialogOpen] = useState(false);
    const [creditCostValue, setCreditCostValue] = useState("");
    const [creditCostId, setCreditCostId] = useState(null);
    const [isUpdatingCreditCost, setIsUpdatingCreditCost] = useState(false);

    const creditcost = async () => {
        try {
            const response = await axios.get('/api/admin/credit-cost-config/?key=clone_agent', { withCredentials: true });
            if (response.data.results && response.data.results.length > 0) {
                setCreditCostValue(response.data.results[0].default_cost);
                setCreditCostId(response.data.results[0].id);
            }
        } catch (error) {
            triggerAlert('error', '', error.response?.data?.error || 'Failed to get credit cost');
        }
    }
    useEffect(() => {
        creditcost();
    }, [])

    const handleUpdateCreditCost = async () => {
        setIsUpdatingCreditCost(true);
        try {
            const payload = {
                key: "clone_agent",
                default_cost: creditCostValue,
                description: "Default cost for cloning any agent"
            };
            if (creditCostId) {
                payload.id = creditCostId;
                await axios.patch(`/api/admin/credit-cost-config/${creditCostId}/`, payload, { withCredentials: true });
            } else {
                await axios.post(`/api/admin/credit-cost-config/`, payload, { withCredentials: true });
            }
            triggerAlert('success', '', 'Credit cost updated successfully!');
            setCreditCostDialogOpen(false);
            creditcost();
            fetchAgentsForFolder(currentPage, perPage);
        } catch (error) {
            triggerAlert('error', '', error.response?.data?.error || 'Failed to update credit cost');
        } finally {
            setIsUpdatingCreditCost(false);
        }
    };

    // React Hook Form setup
    const { register, handleSubmit, watch, setValue, reset, formState: { errors } } = useForm({
        defaultValues: {
            flow_name: '',
            flow_type: 'in-bound'
        }
    });

    const selectedFlowType = watch('flow_type');

    useEffect(() => {
        fetchAgentsForFolder();

        access_privileges.map((access, i) => {
            access.sub_module_info.map((subaccess, k) => {
                if (subaccess.name == "Agent Configurations" && subaccess.permissions.indexOf(1) !== -1) {
                    setcustomerlist(true)
                }
                if (subaccess.name == "Agent Configurations" && subaccess.permissions.indexOf(2) !== -1) {
                    setcustomeradd(true)
                }
                if (subaccess.name == "Agent Configurations" && subaccess.permissions.indexOf(3) !== -1) {
                    setcustomeredit(true)
                }
                if (subaccess.name == "Agent Configurations" && subaccess.permissions.indexOf(4) !== -1) {
                    setcustomerdelete(true)
                }

            })


        })
    }, [])
    const menuRef = useRef()


    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const mainHeading = "Callingo Agents";
    const heading = `Digital Employee / ${mainHeading}`;

    // Create Agent API call
    const onSubmitCreateAgent = async (data) => {
        setIsSubmitting(true);
        try {
            const token = getOnlyToken();
            const config = {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
            const payload = {
                flow_name: data.flow_name,
                flow_type: data.flow_type
            }
            const response = await axios.post('/api/admin/default_agent_flow/save/', payload, config);

            if (response.status === 200 || response.status === 201) {
                triggerAlert('success', '', 'Agent flow created successfully!');
                setShowCreateAgentModal(false);
                reset();
                fetchAgentsForFolder(currentPage, perPage);
                setTimeout(() => {
                    navigate('/agentscreation' + `?flowid=${response.data.data.id}&iscreate=true&name=${response.data.data.flow_name}&type=${response.data.data.flow_type}&ivrid=${response.data.data.ivr}&workflowid=${response.data.data.work_flow}`);

                }, 300)
            }
        } catch (error) {
            console.error('Error creating agent flow:', error);
            triggerAlert('error', '', error.response?.data?.message || 'Failed to create agent flow');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCloseCreateAgentModal = () => {
        setShowCreateAgentModal(false);
        reset();
    };



    const fetchAgentsForFolder = async (pageNum = 1, pageSize = 10) => {
        setAgentLoading(true);
        try {
            const response = await _get(`api/agents/agent-dropdown/?pagenumber=${pageNum}&perpage=${pageSize}`);
            if (response.status === 200) {
                // assume agents returned in response.data.agents or response.data.data
                const agents = response.data.data || [];
                const pagination = response.data.pagination || {};
                setListofAiAgents(agents);
                setCurrentPage(pagination.current_page || pageNum);
                setPerPage(pagination.per_page || pageSize);
                setTotalCount(pagination.total_count || 0);
            } else {
                setListofAiAgents([]);
            }
        } catch (error) {
            console.error('Failed to fetch agents for folder', error);
            setListofAiAgents([]);
        } finally {
            setAgentLoading(false);
        }
    };

    const handlePageChange = (page) => {
        fetchAgentsForFolder(page, perPage);
    };

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        fetchAgentsForFolder(1, newPerPage);
    };

    const DeleteAgent = async (data) => {
        try {
            const response = await DeleteAgentByID(data.agent_id);
            const respdata = response.data;
            if (response.status === 200) {
                triggerAlert('success', '', `Agent deleted successfully` || 'Something went wrong');
                // refresh agents for current folder
                fetchAgentsForFolder(currentPage, perPage);
            }
        } catch (error) {
            triggerAlert('error', '', error.response.data.message || 'Something went wrong');
            console.error(error);
        }
    }


    const handleTogglePublish = async (agent, event) => {
        if (event) {
            event.stopPropagation();
        }

        const newPublish = !agent.publish_status;

        try {
            const token = getOnlyToken();
            const config = { headers: { Authorization: `Bearer ${token}` } };
            await axios.put(`/api/admin/agent/update/`, {
                publish_status: newPublish,
                agent_id: agent.agent_id
            }, config);

            triggerAlert('success', '', `Agent ${newPublish ? 'published' : 'unpublished'} successfully`);
            fetchAgentsForFolder(currentPage, perPage);
        } catch (error) {
            triggerAlert('error', '', 'Failed to update publish status');
        }
    };

    const columns = [
        {
            name: "S.NO",
            width: "90px",
            selector: (row, index) => index + 1,
            sortable: true,
        },
        {
            name: "Agent",
            sortable: true,
            cell: (row) => (
                <div className="d-flex align-items-center gap-2" style={{ maxWidth: "250px" }}>
                    <span
                        className="text-primary fw-bold"
                        title={row.agent_name}
                        style={{
                            maxWidth: "250px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "block",
                        }}
                    >
                        {row.agent_name}
                    </span>
                </div>
            ),
        },
        {
            name: 'Position',
            selector: row => row.agent_position,
            sortable: true,
        },
         {
            name: 'Agent Type',
            selector: row => row.agent_type ,
            sortable: true,
            cell: row => (
                <span className={`badge ${row.agent_type === 'both' ? 'bg-primary' : row.agent_type === 'in-bound' ? 'bg-info' : row.agent_type === 'out-bound' ? 'bg-warning' : 'text-black'} `}>
                    {row.agent_type === 'in-bound' ? 'Inbound' : row.agent_type === 'out-bound' ? 'Outbound' : row.agent_type === 'both' ? 'Both' : '--'}
                    </span>

            ),
        },
        // {
        //     name: "Duration",
        //     center: true,
        //     sortable: true,
        //     cell: (row) => (
        //         <span className="badge bg-primary-subtle text-white fw-semibold px-2 py-1">
        //             {row.meeting_duration || 0} mins
        //         </span>
        //     ),
        // },
     
        // {
        //     name: (
        //         <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        //             Credit Cost
        //             {customeredit && (
        //                 <i
        //                     className="bi bi-pencil-square"
        //                     style={{ cursor: 'pointer', fontSize: '1.1rem', color: '#ffffff' }}
        //                     onClick={(e) => {
        //                         e.stopPropagation();
        //                         setCreditCostDialogOpen(true);
        //                     }}
        //                     title="Edit Default Cost (USD)"
        //                 ></i>
        //             )}
        //         </div>
        //     ),
        //     selector: row => row.credits_cost,
        //     sortable: true,
        // },
        {
            name: (
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    Agent Cost
                </div>
            ),
            selector: row => row.agent_plan?.pack_price || 0,
            sortable: true,
            cell: row => (
                <span>
                    ${row.agent_plan?.pack_price || 0}
                </span>
            ),
        },
        {
            name: (
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    Duration
                </div>
            ),
            selector: row => row.agent_plan?.pack_units || 0,
            sortable: true,
            cell: row => (
                <span>
                    {row.agent_plan?.pack_units || 0} mins
                </span>
            ),
        },
        {
            name: 'Status',
            width: '200px',
            center: true,
            cell: row => (
                <span className={`badge ${row.is_active ? 'bg-success' : 'bg-secondary'}`}>
                    {row.is_active ? 'Active' : 'Inactive'}
                </span>
            ),
        },
           {
            name: 'Created',
            selector: row => row.created_at,
            sortable: true,
            cell: row => moment(row.created_at).fromNow(),
        },
        {
            name: 'Publish',
            width: '130px',
            cell: row => (
                <div className="form-check form-switch" onClick={(e) => e.stopPropagation()}>
                    {row.agent_type == "out-bound" ?  <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        checked={!!row.publish_status}
                        onChange={(e) => handleTogglePublish(row, e)}
                        style={{ cursor: 'pointer', width: '2.5rem', height: '1.25rem' }}
                    /> : ""}
                     
                </div>
            ),
        },
        {
            name: 'Actions',
            cell: row => (
                <div className="action-container">
                    {/* Edit */}
                    {customeredit && <Link
                        to={`/configurations/agentscreation?agentid=${row.agent_id}&isupdate=true`}
                        className="action-btn edit-btn"
                        title="Edit"
                    >
                        <i className="bi bi-pencil-square"></i>
                    </Link>}


                    {/* Delete */}
                    {customerdelete && <span
                        className="action-btn delete-btn"
                        onClick={() => {
                            ConfirmationAlert(
                                "Do you want to delete agent from database",
                                "Delete",
                                () => DeleteAgent(row)
                            );
                        }}
                        title="Delete"
                    >
                        <i className="bi bi-trash-fill"></i>
                    </span>}
                </div>
            ),
        }


    ]
    const customStyles = {
        table: {
            style: {
                backgroundColor: "#ffffff",
                borderRadius: "8px",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#064c77",
                borderBottom: "1px solid #dee2e6",
                minHeight: "52px",
            },
        },
        headCells: {
            style: {
                color: "#ffffff",
                fontSize: "13px",
                fontWeight: "700",
                textTransform: "uppercase",
            },
        },
        rows: {
            style: {
                minHeight: "56px",
                backgroundColor: "#ffffff",
                "&:hover": {
                    backgroundColor: "#f8f9fa",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                },
            },
        },
        cells: {
            style: {
                fontSize: "14px",
                color: "#495057",
                borderBottom: "1px solid #f1f3f5",
            },
        },
        pagination: {
            style: {
                borderTop: "1px solid #dee2e6",
                padding: "8px",
            },
        },
        noData: {
            style: {
                backgroundColor: "#ffffff",
                color: "#6c757d",
                padding: "24px",
            },
        },
    };

    return (
        <>

            <div id='layout-wrapper'>
                <Header />
                <Sidebar />
                <div className='page-content' style={{ backgroundColor: "#ededed" }}>

                    <div className="main-content">
                        <PageHeader mainHeading={mainHeading} heading={heading} />
                        <div className=' '>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">

                                        <div className="page-title-box">
                                            <div className="page-title-right">
                                                <div className="d-flex  justify-content-end ">


                                                    {customeradd ? <button className="btn btn-primary d-flex align-items-center gap-1" onClick={() => navigate('/configurations/agentscreation')}  >   Create Agent </button> : ""}


                                                </div>

                                            </div>
                                            {/* <h4 className="page-title">AI Agents</h4> */}

                                        </div>
                                    </div>
                                </div>
                                <div className="card border-0 shadow-sm " >
                                    <div className="row">
                                        <div className="col-12" >
                                            <div className="">
                                                <DataTable
                                                    columns={columns}
                                                    data={ListofAiAgents}
                                                    progressPending={agentLoading}
                                                    progressComponent={
                                                        <div className='loader-overlay text-white'>
                                                            <Loader />
                                                        </div>
                                                    }
                                                    customStyles={customStyles}
                                                    pagination
                                                    paginationServer
                                                    paginationTotalRows={totalCount}
                                                    paginationDefaultPage={currentPage}
                                                    paginationPerPage={perPage}
                                                    onChangeRowsPerPage={handlePerPageChange}
                                                    onChangePage={handlePageChange}
                                                    paginationRowsPerPageOptions={[10, 20, 30, 50]}
                                                    noDataComponent={<p className="text-muted py-4">No AI Agents found.</p>}
                                                    pointerOnHover
                                                />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


            {/* UPDATE CREDIT COST MODAL */}
            <Modal
                show={creditCostDialogOpen}
                onHide={() => setCreditCostDialogOpen(false)}
                centered
                backdrop="static"
                contentClassName="border-0 shadow-lg rounded-4"
            >
                <Modal.Body className="p-4">
                    <button
                        type="button"
                        className="btn-close position-absolute"
                        style={{ top: '16px', right: '16px' }}
                        onClick={() => setCreditCostDialogOpen(false)}
                        aria-label="Close"
                    />
                    <h4 className="fw-bold mb-2" style={{ color: '#014670' }}>Update Default Cost (USD)</h4>
                    <p className="text-muted mb-4 fs-6">
                        Set the default cost in USD (up to 4 decimal places, min $0.0001).
                    </p>
                    <div className="mb-4">
                        <label className="form-label fw-semibold">Default Cost ($)</label>
                        <input
                            type="number"
                            step="0.0001"
                            min="0"
                            className="form-control"
                            value={creditCostValue}
                            onChange={(e) => setCreditCostValue(e.target.value)}
                            placeholder="e.g., 0.1500"
                            style={{ borderRadius: '8px', padding: '12px 16px', fontSize: '14px' }}
                        />
                    </div>
                    <div className="d-flex justify-content-end gap-3 mt-4">
                        <Button
                            variant="secondary"
                            onClick={() => setCreditCostDialogOpen(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleUpdateCreditCost}
                            disabled={isUpdatingCreditCost || !creditCostValue}
                        >
                            {isUpdatingCreditCost ? 'Updating...' : 'Update'}
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            {/* SUCCESS MODAL */}
            <Modal
                show={showSuccessModal}
                onHide={() => setShowSuccessModal(false)}
                centered
                backdrop="static"
                contentClassName="border-0 shadow-lg rounded-4"
            >
                <Modal.Body className="p-4 text-center">
                    <div
                        className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                        style={{
                            width: 80,
                            height: 80,
                            background: "linear-gradient(135deg, #28a745, #20c997)",
                        }}
                    >
                        <i className="bi bi-check-lg text-white" style={{ fontSize: "2.5rem" }} />
                    </div>
                    <h5 className="fw-bold mb-2">Success</h5>
                    <p className="text-muted mb-4">{successMessage}</p>
                    <button
                        className="btn btn-success px-4 fw-semibold rounded-pill"
                        onClick={() => setShowSuccessModal(false)}
                    >
                        Done
                    </button>
                </Modal.Body>
            </Modal>

            {/* ERROR MODAL */}
            <Modal
                show={showErrorModal}
                onHide={() => setShowErrorModal(false)}
                centered
                backdrop="static"
                contentClassName="border-0 shadow-lg rounded-4"
            >
                <Modal.Body className="p-4 text-center">
                    <div
                        className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                        style={{
                            width: 80,
                            height: 80,
                            background: "linear-gradient(135deg, #dc3545, #ff6b6b)",
                        }}
                    >
                        <i className="bi bi-x-lg text-white" style={{ fontSize: "2.2rem" }} />
                    </div>
                    <h5 className="fw-bold mb-2">Something went wrong</h5>
                    <p className="text-muted mb-4">{errorMessage}</p>
                    <button
                        className="btn btn-outline-danger px-4 fw-semibold rounded-pill"
                        onClick={() => setShowErrorModal(false)}
                    >
                        Close
                    </button>
                </Modal.Body>
            </Modal>

            {/* CREATE AGENT MODAL */}
            <Modal
                show={showCreateAgentModal}
                onHide={handleCloseCreateAgentModal}
                centered
                backdrop="static"
                contentClassName="border-0 shadow-lg rounded-4"
            >
                <Modal.Body className="p-4">
                    {/* Close button */}
                    <button
                        type="button"
                        className="btn-close position-absolute"
                        style={{ top: '16px', right: '16px' }}
                        onClick={handleCloseCreateAgentModal}
                        aria-label="Close"
                    />

                    {/* Title */}
                    <h4 className="fw-bold mb-2 " style={{ color: '#014670' }}>Create New Agent</h4>
                    <p className="text-muted mb-4 fs-6" >
                        Define the basic parameters for your new communication flow.
                    </p>

                    <Form onSubmit={handleSubmit(onSubmitCreateAgent)}>
                        {/* Flow Name */}
                        <Form.Group className="mb-4">
                            <Form.Label className="fw-semibold">
                                Agent Name <span className='text-danger'>*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                className='form-control'
                                placeholder="e.g., Summer Marketing Campaign"
                                {...register('flow_name', { required: 'Agent name is required' })}
                                isInvalid={!!errors.flow_name}
                                style={{
                                    // border: '1px solid #e0e0e0',
                                    borderRadius: '8px',
                                    padding: '12px 16px',
                                    fontSize: '14px'
                                }}
                            />
                            {errors.flow_name && (
                                <Form.Control.Feedback type="invalid">
                                    {errors.flow_name.message}
                                </Form.Control.Feedback>
                            )}
                        </Form.Group>

                        {/* Communication Type */}
                        <Form.Group className="mb-4">
                            <Form.Label className="fw-semibold mb-3">Communication Type</Form.Label>
                            <div className="d-flex gap-3">
                                {/* Inbound Option */}
                                <div
                                    onClick={() => setValue('flow_type', 'in-bound')}
                                    style={{
                                        flex: 1,
                                        border: selectedFlowType === 'in-bound' ? '2px solid #198754' : '1px dashed #909296',
                                        borderRadius: '12px',
                                        padding: '16px',
                                        cursor: 'pointer',
                                        backgroundColor: selectedFlowType === 'in-bound' ? '#f8fff9' : '#fff',
                                        transition: 'all 0.2s ease'
                                    }}
                                >
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                        <i
                                            className="bi bi-telephone-inbound"
                                            style={{
                                                color: selectedFlowType === 'in-bound' ? '#198754' : '#6c757d',
                                                fontSize: '18px'
                                            }}
                                        />
                                        <span
                                            className="fw-semibold"
                                            style={{ color: selectedFlowType === 'in-bound' ? '#198754' : '#333' }}
                                        >
                                            Inbound
                                        </span>
                                    </div>
                                    <small className="text-muted" style={{ fontSize: '11px' }}>USER INITIATES</small>
                                </div>

                                {/* Outbound Option */}
                                <div
                                    onClick={() => setValue('flow_type', 'out-bound')}
                                    style={{
                                        flex: 1,
                                        border: selectedFlowType === 'out-bound' ? '2px solid #198754' : '1px dashed #909296',
                                        borderRadius: '12px',
                                        padding: '16px',
                                        cursor: 'pointer',
                                        backgroundColor: selectedFlowType === 'out-bound' ? '#f8fff9' : '#fff',
                                        transition: 'all 0.2s ease'
                                    }}
                                >
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                        <i
                                            className="bi bi-telephone-outbound"
                                            style={{
                                                color: selectedFlowType === 'out-bound' ? '#198754' : '#6c757d',
                                                fontSize: '18px'
                                            }}
                                        />
                                        <span
                                            className="fw-semibold"
                                            style={{ color: selectedFlowType === 'out-bound' ? '#198754' : '#333' }}
                                        >
                                            Outbound
                                        </span>
                                    </div>
                                    <small className="text-muted" style={{ fontSize: '11px' }}>AGENT INITIATES</small>
                                </div>
                            </div>
                            <input type="hidden" {...register('flow_type')} />
                        </Form.Group>

                        {/* Action Buttons */}
                        <div className="d-flex justify-content-center gap-3 mt-4">
                            <Button
                                variant="secondary"
                                onClick={handleCloseCreateAgentModal}
                                style={{
                                    padding: '10px 32px',
                                    borderRadius: '8px',
                                    fontWeight: 500
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                disabled={isSubmitting}
                                style={{
                                    // backgroundColor: '#198754',
                                    border: 'none',
                                    padding: '10px 24px',
                                    borderRadius: '8px',
                                    fontWeight: 500,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}
                                className='btn btn-primary'
                            >
                                {isSubmitting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Processing...
                                    </>
                                ) : (
                                    <>
                                        Initialize Agent
                                        <i className="bi bi-arrow-right"></i>
                                    </>
                                )}
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>



        </>
    )
}
